import { useEffect, useState, useMemo } from 'react'
import { Button, Dropdown, Space, Tooltip } from 'antd';
import { DownOutlined, EyeInvisibleOutlined, EyeOutlined, LogoutOutlined } from '@ant-design/icons';
import UserAvatar from '../User/UserAvatar';
import { Link, useNavigate } from 'react-router-dom';
import { isAuthenticated, getJwtToken, getStoredUser } from '../../utilities/authentication';
import { useDispatch, useSelector } from 'react-redux';
import { LogOutHand } from '../../store/Auth/LogOutSlice';
import { setPriceVisibility } from '../../store/PriceVisibility/PriceVisibilitySlice';
import useTranslation from '../../localization/useTranslation';
import { getVendorLogoPublicUrl } from '../../utilities/vendorLogoUrl';
import { shell } from '../../theme/palette';
import NotificationsBell from './NotificationsBell';

const NavBar = ({ compact = false }) => {
  const dispatch = useDispatch()
  const { theme } = useSelector(state => state.theme)
  const { language } = useSelector(state => state.language)
  const { settings } = useSelector((state) => state.settings)
  const { showPrices } = useSelector((state) => state.priceVisibility)
  const profileUser = useSelector((state) => state.profile?.user)
  const [user, setUser] = useState(null)
  const navigate = useNavigate()
  const { t } = useTranslation();
  const colors = theme === 'dark' ? shell.dark : shell.light;

  const token = getJwtToken()
  const vendorLogoUrl = useMemo(() => getVendorLogoPublicUrl(settings?.logo_path), [settings?.logo_path])

  useEffect(() => {
    if (!isAuthenticated()) {
      setUser(null)
      return
    }
    if (profileUser && typeof profileUser === 'object') {
      setUser(profileUser)
      return
    }
    setUser(getStoredUser())
  }, [profileUser])

  const handleMenuClick = ({ key }) => {
    const actionRoutes = {
      profile: '/profile',
      settings: '/setting/lab-info',
    }

    if (key === 'logout') {
      dispatch(LogOutHand(token))
      return
    }

    const targetPath = actionRoutes[key]

    if (targetPath) {
      navigate(targetPath)
    }
  }

  const menuItems = useMemo(() => ([
    {
      key: 'profile',
      label: t('profile.menu.profile'),
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: t('profile.menu.logout'),
    },
  ]), [t])

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        justifyContent: language === 'ar' ? 'flex-end' : 'flex-start',
        direction: language === 'ar' ? 'rtl' : 'ltr'
      }}
    >
      {
        isAuthenticated() ?
          <>
            {vendorLogoUrl ? (
              <img
                className="navbar-vendor-logo"
                src={vendorLogoUrl}
                alt={settings?.name || t('lab.field.logo')}
                style={{
                  maxHeight: compact ? 28 : 36,
                  maxWidth: compact ? 100 : 140,
                  width: 'auto',
                  objectFit: 'contain',
                }}
              />
            ) : null}
            <NotificationsBell />
            <Tooltip title={showPrices ? t('ui.prices.hide') : t('ui.prices.show')}>
              <Button
                type="text"
                aria-label={showPrices ? t('ui.prices.hide') : t('ui.prices.show')}
                icon={showPrices ? <EyeOutlined /> : <EyeInvisibleOutlined />}
                onClick={() => dispatch(setPriceVisibility(!showPrices))}
                style={{ color: colors.text }}
              />
            </Tooltip>
            <Dropdown
              menu={{ items: menuItems, onClick: handleMenuClick }}
              trigger={['click']}
              placement={language === 'ar' ? "bottomRight" : "bottomLeft"}
            >
              <span style={{ display: 'inline-block', cursor: 'pointer', maxWidth: '100%' }}>
                <Space
                  style={{
                    color: colors.text,
                    fontWeight: 500,
                    direction: language === 'ar' ? 'rtl' : 'ltr',
                  }}
                >
                  <UserAvatar user={typeof user === 'object' ? user : null} size={compact ? 26 : 28} />
                  {!compact ? (
                    <span className="navbar-user-name">
                      {typeof user === 'string' ? user : user?.name ?? 'المستخدم'}
                    </span>
                  ) : null}
                  <DownOutlined />
                </Space>
              </span>
            </Dropdown>
          </>
          :
          <Link
            to={"/"}
            style={{ color: colors.text }}
          >
            تسجيل دخول
          </Link>
      }
    </div>
  )
}

export default NavBar
